import React, { useEffect, useState } from 'react';
import './Hero.css';

const APPOINTMENTS = [
  { time: '09:00 AM', name: 'Dr. Sharma', dept: 'Cardiology', status: 'done' },
  { time: '09:30 AM', name: 'Dr. Patel',  dept: 'Orthopedics', status: 'active' },
  { time: '10:00 AM', name: 'Dr. Kumar',  dept: 'Neurology', status: 'pending' },
  { time: '10:30 AM', name: 'Dr. Singh',  dept: 'General OPD', status: 'pending' },
];

const StatusBadge = ({ status }) => (
  <span className={`appt-status appt-status--${status}`}>
    {status === 'done' ? 'Done' : status === 'active' ? 'In Progress' : 'Waiting'}
  </span>
);

const DashboardMockup = () => {
  const [activeAppt, setActiveAppt] = useState(1);

  useEffect(() => {
    const t = setInterval(() => {
      setActiveAppt((v) => (v + 1) % APPOINTMENTS.length);
    }, 2200);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="dashboard">
      {/* Header */}
      <div className="dashboard__header">
        <div className="dashboard__header-left">
          <span className="dashboard__title">HMS Dashboard</span>
          <span className="dashboard__date">Sat, 31 May 2026</span>
        </div>
        <div className="dashboard__live">
          <span className="live-dot" />
          LIVE
        </div>
      </div>

      {/* Stats Row */}
      <div className="dashboard__stats">
        <div className="stat-widget stat-widget--cyan">
          <div className="stat-widget__icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="square">
              <rect x="3" y="4" width="18" height="18"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
            </svg>
          </div>
          <div className="stat-widget__value">24</div>
          <div className="stat-widget__label">Appointments</div>
        </div>

        <div className="stat-widget stat-widget--dark">
          <div className="stat-widget__icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="square">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>
          </div>
          <div className="stat-widget__value">128</div>
          <div className="stat-widget__label">Active Patients</div>
        </div>

        <div className="stat-widget stat-widget--green">
          <div className="stat-widget__icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="square">
              <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
            </svg>
          </div>
          <div className="stat-widget__value">12</div>
          <div className="stat-widget__label">Doctors Available</div>
        </div>

        <div className="stat-widget stat-widget--blue">
          <div className="stat-widget__icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="square">
              <line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
            </svg>
          </div>
          <div className="stat-widget__value">₹48.2K</div>
          <div className="stat-widget__label">Today's Revenue</div>
        </div>
      </div>

      {/* Appointments */}
      <div className="dashboard__section-title">Today's Appointments</div>
      <div className="dashboard__appointments">
        {APPOINTMENTS.map((appt, i) => (
          <div
            key={i}
            className={`appt-row${i === activeAppt ? ' appt-row--active' : ''}`}
          >
            <span className="appt-time">{appt.time}</span>
            <span className="appt-name">{appt.name}</span>
            <span className="appt-dept">{appt.dept}</span>
            <StatusBadge status={appt.status} />
          </div>
        ))}
      </div>

      {/* Revenue Bar */}
      <div className="dashboard__revenue">
        <div className="revenue__header">
          <span className="revenue__label">Revenue Overview</span>
          <span className="revenue__pct">80%</span>
        </div>
        <div className="revenue__bar">
          <div className="revenue__fill" style={{ width: '80%' }} />
        </div>
        <div className="revenue__header" style={{ marginTop: 8 }}>
          <span className="revenue__label">Target Patients</span>
          <span className="revenue__pct">62%</span>
        </div>
        <div className="revenue__bar">
          <div className="revenue__fill revenue__fill--alt" style={{ width: '62%' }} />
        </div>
      </div>

      {/* Follow-ups */}
      <div className="dashboard__followup">
        <div className="followup__icon">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="square">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>
          </svg>
        </div>
        <span className="followup__text">Pending Follow-ups</span>
        <span className="followup__badge">8</span>
      </div>
    </div>
  );
};

const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="container hero__inner">
        {/* Left */}
        <div className="hero__content">
          {/* <div className="hero__eyebrow">
            <span className="hero__eyebrow-tag">
              <span className="eyebrow-dot" />
              Trusted by 500+ Healthcare Facilities
            </span>
          </div> */}

          <h1 className="hero__headline">
            The Complete Hospital Management System for
            <span className="hero__headline-accent"> Modern Healthcare</span>
          </h1>

          <p className="hero__sub">
            Manage appointments, doctors, prescriptions, pharmacy operations, patient records,
            and hospital workflows from a single intelligent platform.
          </p>

            {/* <div className="hero__ctas">
            <a href="#demo" className="btn-primary">
              Request Demo
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="square">
                <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
              </svg>
            </a>
            <a href="#contact" className="btn-secondary">
              Book Consultation
            </a>
          </div> */}

          <div className="hero__trust">
            <div className="trust-item">
              <span className="trust-check">✓</span>
              <span>No Setup Fees</span>
            </div>
            <div className="trust-item">
              <span className="trust-check">✓</span>
              <span>NABH Compliant</span>
            </div>
            <div className="trust-item">
              <span className="trust-check">✓</span>
              <span>24/7 Support</span>
            </div>
          </div>
        </div>

        {/* Right - Dashboard Mockup */}
        <div className="hero__mockup">
          <DashboardMockup />
          <div className="mockup-glow" />
        </div>
      </div>

      {/* Bottom wave/divider */}
      <div className="hero__clients">
        <div className="container">
          <span className="hero__clients-label">Powering operations at leading healthcare groups</span>
          <div className="hero__clients-logos">
            {['Apollo-Style Clinics', 'City Medical Centre', 'Metro Hospitals', 'CureZone Network', 'HealthFirst Chain'].map((name) => (
              <div key={name} className="client-logo-pill">{name}</div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
